import { useMemo } from 'react';
import { PasswordPolicy } from '../../slices/types';
import { PasswordValidationState } from './types';

export const usePasswordValidation = (
    password1: string,
    password2: string,
    passwordPolicy: PasswordPolicy
): PasswordValidationState & { isValid: boolean } => {
    const validationState = useMemo<PasswordValidationState>(() => {
        const hasMinLength = password1.length >= passwordPolicy.minLength;
        const hasLetter = passwordPolicy.requiresLetter ? /[a-zA-Z]/.test(password1) : true;
        const hasNumber = passwordPolicy.requiresNumber ? /\d/.test(password1) : true;
        const hasSymbol = passwordPolicy.requiresSymbol
            ? /[!@#$%^&*(),.?":{}|<>]/.test(password1)
            : true;
        const hasUppercase = passwordPolicy.requiresUppercase ? /[A-Z]/.test(password1) : true;
        const passwordsMatch = password1 === password2 && password1.length > 0;

        return {
            hasMinLength,
            hasLetter,
            hasNumber,
            hasSymbol,
            hasUppercase,
            passwordsMatch,
        };
    }, [password1, password2, passwordPolicy]);

    return {
        ...validationState,
        isValid: Object.values(validationState).every(Boolean),
    };
};
